export const getActionOptions = (prefix) => ({ prefix, namespace: '/' });
